<template>
  <SettingsPageLayout>
    <DashboardQuickstart @handle-setup-complete="handleSetupComplete" />
  </SettingsPageLayout>
</template>

<script setup lang="ts">
import { useRouter } from 'vue-router';
import SettingsPageLayout from '../layouts/SettingsPageLayout/index.vue';
import DashboardQuickstart from '../dashboard_quickstart/DashboardQuickstart.vue';
import { toast } from 'vue-sonner';

const router = useRouter();

const handleSetupComplete = () => {
  router.push('/settings/account/profile');
  toast.success('Guided Account Setup Complete!', {
    action: { label: 'Dismiss' },
    description: 'Congrats, you have completed the guided account setup. Use the button below to dismiss this alert.',
  });
};
</script>
